import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { useRoleCheck } from 'hooks/useRoleCheck';
import { UserRole } from 'types/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  roles?: UserRole[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, roles }) => {
  const { isAuthenticated } = useAuth();
  const { hasAnyRole } = useRoleCheck();

  if (!isAuthenticated) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  if (roles && roles.length > 0 && !hasAnyRole(roles)) {
    // If roles are specified but user doesn't have any of them, redirect to default page
    return <Navigate to="/admin/default" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 